// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import 'bootstrap'
// Required by Blacklight
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap
import Blacklight from "blacklight-frontend";
window.Blacklight = Blacklight
import "blacklight-frontend"

// Required by Spotlight
import githubAutoCompleteElement from "@github/auto-complete-element";
import "./spotlight"
import "openseadragon"
import "openseadragon-rails"
import "./blacklight_oembed"
import "blacklight-gallery/blacklight-gallery.esm.js"
 
import "./pages_block_overrides"
import "./sir_trevor_block_overrides"
